import * as React from "react";

import { cn } from "@/shared/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
    return (
        <input
            type={type}
            data-slot="input"
            className={cn(
                "file:text-foreground placeholder:text-content-placeholder selection:bg-primary selection:text-primary-foreground border-input-default bg-input md:text-m file:text-s text-m flex w-full min-w-0 rounded-md border px-2.75 py-1.75 shadow-xs transition-[color,box-shadow] file:inline-flex file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                "focus-visible:outline-focus focus-visible:border-transparent focus-visible:outline-2",
                "aria-invalid:outline-error aria-invalid:border-transparent aria-invalid:outline-2",
                "hover:border-input-hover",
                className
            )}
            {...props}
        />
    );
}

export { Input };
